__turbopack_context__.v({
  "blueLine": "index-module__ec0obW__blueLine",
  "redLine": "index-module__ec0obW__redLine",
  "root": "index-module__ec0obW__root",
  "yellowLine": "index-module__ec0obW__yellowLine",
});
